// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as $$String from "rescript/lib/es6/string.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Js_math from "rescript/lib/es6/js_math.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Js_option from "rescript/lib/es6/js_option.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as Pervasives from "rescript/lib/es6/pervasives.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";
import * as Config$LiveRoom from "../../Config.bs.js";
import * as Utils_Web$LiveRoom from "../Utils/Utils_Web.bs.js";
import * as Auth0Client$LiveRoom from "../auth0/Auth0Client.bs.js";
import * as Translations$LiveRoom from "../../../translations/Translations.bs.js";
import * as GraphQLFetchClient$LiveRoom from "../GraphQLFetchClient.bs.js";
import * as ClientApiBaseClient$LiveRoom from "../ClientApiBaseClient.bs.js";

var AuthenticationError = /* @__PURE__ */Caml_exceptions.create("AuthTokenHook-LiveRoom.AuthenticationError");

var ppx_printed_query = "query UserQuery  {\nuser: me  {\nid  \nvikingId  \nstatus  {\n__typename\n...on BasicUserStatus   {\n__typename  \npartyId  \n}\n\n...on DowngradedUserStatus   {\n__typename  \npartyId  \n}\n\n...on TransactionalUserStatus   {\n__typename  \npartyId  \n}\n\n}\n\n}\n\n}\n";

function parse(value) {
  var value$1 = Js_option.getExn(Js_json.decodeObject(value));
  var value$2 = Js_dict.get(value$1, "user");
  var tmp;
  if (value$2 !== undefined) {
    var value$3 = Js_option.getExn(Js_json.decodeObject(Caml_option.valFromOption(value$2)));
    var value$4 = Js_dict.get(value$3, "id");
    var tmp$1;
    if (value$4 !== undefined) {
      var value$5 = Caml_option.valFromOption(value$4);
      var value$6 = Js_json.decodeString(value$5);
      tmp$1 = value$6 !== undefined ? value$6 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$5));
    } else {
      tmp$1 = Js_exn.raiseError("graphql_ppx: Field id on type User is missing");
    }
    var value$7 = Js_dict.get(value$3, "vikingId");
    var tmp$2;
    if (value$7 !== undefined) {
      var value$8 = Caml_option.valFromOption(value$7);
      var value$9 = Js_json.decodeString(value$8);
      tmp$2 = value$9 !== undefined ? value$9 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$8));
    } else {
      tmp$2 = Js_exn.raiseError("graphql_ppx: Field vikingId on type User is missing");
    }
    var value$10 = Js_dict.get(value$3, "status");
    var tmp$3;
    if (value$10 !== undefined) {
      var value$11 = Caml_option.valFromOption(value$10);
      var typename_obj = Js_json.decodeObject(value$11);
      if (typename_obj !== undefined) {
        var typename = Js_dict.get(Caml_option.valFromOption(typename_obj), "__typename");
        if (typename !== undefined) {
          var typename$1 = Js_json.decodeString(Caml_option.valFromOption(typename));
          if (typename$1 !== undefined) {
            switch (typename$1) {
              case "BasicUserStatus" :
                  var value$12 = Js_option.getExn(Js_json.decodeObject(value$11));
                  var value$13 = Js_dict.get(value$12, "__typename");
                  var tmp$4;
                  if (value$13 !== undefined) {
                    var value$14 = Caml_option.valFromOption(value$13);
                    var value$15 = Js_json.decodeString(value$14);
                    tmp$4 = value$15 !== undefined ? value$15 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$14));
                  } else {
                    tmp$4 = Js_exn.raiseError("graphql_ppx: Field __typename on type BasicUserStatus is missing");
                  }
                  var value$16 = Js_dict.get(value$12, "partyId");
                  var tmp$5;
                  if (value$16 !== undefined) {
                    var value$17 = Caml_option.valFromOption(value$16);
                    var value$18 = Js_json.decodeString(value$17);
                    tmp$5 = value$18 !== undefined ? value$18 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$17));
                  } else {
                    tmp$5 = Js_exn.raiseError("graphql_ppx: Field partyId on type BasicUserStatus is missing");
                  }
                  tmp$3 = {
                    NAME: "BasicUserStatus",
                    VAL: {
                      __typename: tmp$4,
                      partyId: tmp$5
                    }
                  };
                  break;
              case "DowngradedUserStatus" :
                  var value$19 = Js_option.getExn(Js_json.decodeObject(value$11));
                  var value$20 = Js_dict.get(value$19, "__typename");
                  var tmp$6;
                  if (value$20 !== undefined) {
                    var value$21 = Caml_option.valFromOption(value$20);
                    var value$22 = Js_json.decodeString(value$21);
                    tmp$6 = value$22 !== undefined ? value$22 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$21));
                  } else {
                    tmp$6 = Js_exn.raiseError("graphql_ppx: Field __typename on type DowngradedUserStatus is missing");
                  }
                  var value$23 = Js_dict.get(value$19, "partyId");
                  var tmp$7;
                  if (value$23 !== undefined) {
                    var value$24 = Caml_option.valFromOption(value$23);
                    var value$25 = Js_json.decodeString(value$24);
                    tmp$7 = value$25 !== undefined ? value$25 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$24));
                  } else {
                    tmp$7 = Js_exn.raiseError("graphql_ppx: Field partyId on type DowngradedUserStatus is missing");
                  }
                  tmp$3 = {
                    NAME: "DowngradedUserStatus",
                    VAL: {
                      __typename: tmp$6,
                      partyId: tmp$7
                    }
                  };
                  break;
              case "TransactionalUserStatus" :
                  var value$26 = Js_option.getExn(Js_json.decodeObject(value$11));
                  var value$27 = Js_dict.get(value$26, "__typename");
                  var tmp$8;
                  if (value$27 !== undefined) {
                    var value$28 = Caml_option.valFromOption(value$27);
                    var value$29 = Js_json.decodeString(value$28);
                    tmp$8 = value$29 !== undefined ? value$29 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$28));
                  } else {
                    tmp$8 = Js_exn.raiseError("graphql_ppx: Field __typename on type TransactionalUserStatus is missing");
                  }
                  var value$30 = Js_dict.get(value$26, "partyId");
                  var tmp$9;
                  if (value$30 !== undefined) {
                    var value$31 = Caml_option.valFromOption(value$30);
                    var value$32 = Js_json.decodeString(value$31);
                    tmp$9 = value$32 !== undefined ? value$32 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$31));
                  } else {
                    tmp$9 = Js_exn.raiseError("graphql_ppx: Field partyId on type TransactionalUserStatus is missing");
                  }
                  tmp$3 = {
                    NAME: "TransactionalUserStatus",
                    VAL: {
                      __typename: tmp$8,
                      partyId: tmp$9
                    }
                  };
                  break;
              default:
                tmp$3 = Js_exn.raiseError("graphql_ppx: Union UserStatus returned unknown type " + typename$1);
            }
          } else {
            tmp$3 = Js_exn.raiseError("graphql_ppx: Union UserStatus has a __typename field that is not a string");
          }
        } else {
          tmp$3 = Js_exn.raiseError("graphql_ppx: Union UserStatus is missing the __typename field");
        }
      } else {
        tmp$3 = Js_exn.raiseError("graphql_ppx: Expected union UserStatus to be an object, got " + JSON.stringify(value$11));
      }
    } else {
      tmp$3 = Js_exn.raiseError("graphql_ppx: Field status on type User is missing");
    }
    tmp = {
      id: tmp$1,
      vikingId: tmp$2,
      status: tmp$3
    };
  } else {
    tmp = Js_exn.raiseError("graphql_ppx: Field user on type Query is missing");
  }
  return {
          user: tmp
        };
}

function make(param) {
  return {
          query: ppx_printed_query,
          variables: null,
          parse: parse
        };
}

function makeWithVariables(param) {
  return {
          query: ppx_printed_query,
          variables: null,
          parse: parse
        };
}

function makeVariables(param) {
  return null;
}

function definition_2(graphql_ppx_use_json_variables_fn) {
  return 0;
}

var definition = [
  parse,
  ppx_printed_query,
  definition_2
];

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var UserStatusGraphQL = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  make: make,
  makeWithVariables: makeWithVariables,
  makeVariables: makeVariables,
  definition: definition,
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var UserStatusQuery = GraphQLFetchClient$LiveRoom.MakeQuery(ClientApiBaseClient$LiveRoom.Make({
          query: ppx_printed_query,
          parse: parse
        }));

function MakeAuthZeroParser($star) {
  var parse = function (userStatusResponse) {
    var tmp;
    try {
      var match = userStatusResponse.user.status;
      var variant = match.NAME;
      tmp = Caml_format.int_of_string(variant === "FutureAddedValue" ? "0" : match.VAL.partyId);
    }
    catch (exn){
      tmp = 0;
    }
    var match$1 = userStatusResponse.user.status;
    var variant$1 = match$1.NAME;
    return {
            partyId: tmp,
            userType: variant$1 === "FutureAddedValue" ? "basic" : (
                variant$1 === "TransactionalUserStatus" ? "transactional" : (
                    variant$1 === "BasicUserStatus" ? "basic" : "transactionalDowngraded"
                  )
              ),
            userId: userStatusResponse.user.vikingId
          };
  };
  var parseAuthResponse = function (auth0Response, userStatusResponse) {
    if (userStatusResponse.TAG === /* Ok */0) {
      return {
              NAME: "Authenticated",
              VAL: {
                value: auth0Response.accessToken,
                expiresIn: auth0Response.expiresIn,
                details: parse(userStatusResponse._0)
              }
            };
    } else {
      return "Unauthenticated";
    }
  };
  return {
          parse: parse,
          parseAuthResponse: parseAuthResponse
        };
}

function parse$1(userStatusResponse) {
  var tmp;
  try {
    var match = userStatusResponse.user.status;
    var variant = match.NAME;
    tmp = Caml_format.int_of_string(variant === "FutureAddedValue" ? "0" : match.VAL.partyId);
  }
  catch (exn){
    tmp = 0;
  }
  var match$1 = userStatusResponse.user.status;
  var variant$1 = match$1.NAME;
  return {
          partyId: tmp,
          userType: variant$1 === "FutureAddedValue" ? "basic" : (
              variant$1 === "TransactionalUserStatus" ? "transactional" : (
                  variant$1 === "BasicUserStatus" ? "basic" : "transactionalDowngraded"
                )
            ),
          userId: userStatusResponse.user.vikingId
        };
}

function parseAuthResponse(auth0Response, userStatusResponse) {
  if (userStatusResponse.TAG === /* Ok */0) {
    return {
            NAME: "Authenticated",
            VAL: {
              value: auth0Response.accessToken,
              expiresIn: auth0Response.expiresIn,
              details: parse$1(userStatusResponse._0)
            }
          };
  } else {
    return "Unauthenticated";
  }
}

var AuthZeroParser = {
  parse: parse$1,
  parseAuthResponse: parseAuthResponse
};

function optionalBoolParam(name, maybeValue) {
  if (maybeValue !== undefined) {
    return name + ("=" + Pervasives.string_of_bool(maybeValue));
  } else {
    return "";
  }
}

function originParam(maybeOrigin) {
  if (maybeOrigin === undefined) {
    return "";
  }
  var value = maybeOrigin ? "sale-registration" : "place-bid";
  return "origin=" + value;
}

function transactionalUpgradeOptionParameters(options) {
  var params = Belt_List.keep({
        hd: optionalBoolParam("showVerifyAccount", options.showVerifyAccount),
        tl: {
          hd: optionalBoolParam("auctionFlow", options.auctionFlow),
          tl: {
            hd: originParam(options.origin),
            tl: {
              hd: Belt_Option.mapWithDefault(options.saleLocation, "", (function (saleLocation) {
                      return "saleLocation=" + saleLocation + "";
                    })),
              tl: {
                hd: Belt_Option.mapWithDefault(options.accountId, "", (function (accountId) {
                        return "accountId=" + accountId + "";
                      })),
                tl: /* [] */0
              }
            }
          }
        }
      }, (function (param) {
          return param.length !== 0;
        }));
  var match = Belt_List.length(params);
  if (match !== 0) {
    return "&" + $$String.concat("&", params);
  } else {
    return "";
  }
}

var showSelectAccountParam = "showSelectAccount";

var accountIdParam = "accountId";

var bidOnBehalfParam = "bidOnBehalf";

var agreementStatusesParamPrefix = "agreement";

function queryParameters(maybeParams) {
  return Belt_Array.reduce(Belt_Array.concat([
                    [
                      showSelectAccountParam,
                      Pervasives.string_of_bool(Belt_Option.getWithDefault(Belt_Option.flatMap(maybeParams, (function (params) {
                                      return params.showSelectAccount;
                                    })), false))
                    ],
                    [
                      accountIdParam,
                      Belt_Option.getWithDefault(Belt_Option.flatMap(maybeParams, (function (params) {
                                  return params.accountId;
                                })), "")
                    ],
                    [
                      bidOnBehalfParam,
                      Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(maybeParams, (function (params) {
                                      return params.bidOnBehalf;
                                    })), Pervasives.string_of_bool), "")
                    ]
                  ], Belt_Option.mapWithDefault(Belt_Option.flatMap(maybeParams, (function (params) {
                              return params.agreementStatuses;
                            })), [], (function (agreementStatuses) {
                          return Belt_Array.map(Js_dict.entries(agreementStatuses), (function (param) {
                                        return [
                                                "" + agreementStatusesParamPrefix + "" + param[0] + "",
                                                Pervasives.string_of_bool(param[1])
                                              ];
                                      }));
                        }))), "", (function (queryString, param) {
                  var value = param[1];
                  if (value !== "") {
                    return Utils_Web$LiveRoom.$$Location.queryStringSetField(queryString, param[0], value);
                  } else {
                    return queryString;
                  }
                })).substring(1);
}

function buildLoginURL(encodedResource) {
  return Config$LiveRoom.values.aemLoginUrl + encodedResource + "&lang=" + Belt_Option.getWithDefault(Translations$LiveRoom.checkLanguageInSession(undefined), "en");
}

function buildRegisterURL(encodedResource) {
  return Config$LiveRoom.values.aemRegisterUrl + encodedResource + "&lang=" + Belt_Option.getWithDefault(Translations$LiveRoom.checkLanguageInSession(undefined), "en");
}

function triggerLogin(redirectUri) {
  window.location.href = buildLoginURL(encodeURIComponent(redirectUri));
}

function triggerRegister(redirectUri) {
  window.location.href = buildRegisterURL(encodeURIComponent(redirectUri));
}

function triggerTransactionalUpgrade(options, redirectParams, transactionalUrl) {
  var currentBrowserLocation = window.location;
  var currentHref = currentBrowserLocation.href;
  var searchParams = currentBrowserLocation.search;
  var separator = searchParams === "" ? "?" : "&";
  var redirectUrl = currentHref + (separator + queryParameters(redirectParams));
  var baseTransactionalUrl = transactionalUrl + ("?redirect=" + (encodeURIComponent(redirectUrl) + (transactionalUpgradeOptionParameters(options) + ("&redirectOnCancel=" + encodeURIComponent(currentHref)) + Belt_Option.mapWithDefault(options.saleNumber, "", (function (saleNumber) {
                return "&saleNumber=" + saleNumber + "";
              })))));
  window.location.href = baseTransactionalUrl;
}

function isRevokedTransactionalUser(tokenDetails) {
  if (tokenDetails.details.partyId !== 0) {
    return tokenDetails.details.userType === "basic";
  } else {
    return false;
  }
}

function isDowngradedTransactionalUser(tokenDetails) {
  if (tokenDetails.details.partyId !== 0) {
    return tokenDetails.details.userType === "transactionalDowngraded";
  } else {
    return false;
  }
}

function auth0CustomDomainConfig(param) {
  return {
          domain: Config$LiveRoom.values.auth0.customDomain,
          clientID: Config$LiveRoom.values.auth0.clientId,
          redirectUri: window.location.origin + Config$LiveRoom.values.auth0.redirectUrlPath,
          responseType: "token id_token",
          responseMode: undefined,
          scope: "email openid",
          audience: Config$LiveRoom.values.auth0.audience
        };
}

function auth0CustomClient(param) {
  return Auth0Client$LiveRoom.make(auth0CustomDomainConfig(undefined));
}

var currentToken = {
  contents: {
    NAME: "TokenInit",
    VAL: "NotRequested"
  }
};

var listeners = {
  contents: /* [] */0
};

function checkSessionWithClient(client) {
  var config = {
    timeout: String(5000)
  };
  return Js_promise.then_((function (x) {
                if (x.TAG !== /* Ok */0) {
                  return Promise.resolve([
                              x,
                              {
                                TAG: /* Error */1,
                                _0: /* [] */0
                              }
                            ]);
                }
                var auth0Response = x._0;
                console.log("Success from auth0");
                return Js_promise.then_((function (x) {
                              var variant = x.NAME;
                              if (variant === "Error") {
                                return Promise.resolve([
                                            {
                                              TAG: /* Ok */0,
                                              _0: auth0Response
                                            },
                                            {
                                              TAG: /* Error */1,
                                              _0: x.VAL
                                            }
                                          ]);
                              } else if (variant === "Data") {
                                return Promise.resolve([
                                            {
                                              TAG: /* Ok */0,
                                              _0: auth0Response
                                            },
                                            {
                                              TAG: /* Ok */0,
                                              _0: x.VAL
                                            }
                                          ]);
                              } else {
                                return Promise.resolve([
                                            {
                                              TAG: /* Ok */0,
                                              _0: auth0Response
                                            },
                                            {
                                              TAG: /* Ok */0,
                                              _0: x.VAL[0]
                                            }
                                          ]);
                              }
                            }), Curry._2(UserStatusQuery.queryAndParse, auth0Response.accessToken, undefined));
              }), Auth0Client$LiveRoom.checkSession(client, config));
}

function notifyListeners(newToken) {
  Belt_List.forEach(listeners.contents, (function (param) {
          Curry._1(param[1], newToken);
        }));
}

function startRefreshLoop(expiresIn) {
  var refreshInterval = Math.imul(Js_math.floor_int(expiresIn / 2.0), 1000);
  setInterval((function (param) {
          Js_promise.then_((function (param) {
                  var auth0Response = param[0];
                  if (auth0Response.TAG === /* Ok */0) {
                    currentToken.contents = Belt_Option.getWithDefault(parseAuthResponse(auth0Response._0, param[1]), "Unauthenticated");
                    notifyListeners(currentToken.contents);
                  } else {
                    currentToken.contents = "Unauthenticated";
                    notifyListeners("Unauthenticated");
                  }
                  return Promise.resolve(undefined);
                }), checkSessionWithClient(Auth0Client$LiveRoom.make(auth0CustomDomainConfig(undefined))));
        }), refreshInterval);
}

function fetchInitialToken(param) {
  return Js_promise.then_((function (param) {
                var auth0Response = param[0];
                if (auth0Response.TAG === /* Ok */0) {
                  currentToken.contents = Belt_Option.getWithDefault(parseAuthResponse(auth0Response._0, param[1]), "Unauthenticated");
                  return Promise.resolve(undefined);
                }
                var auth_error = auth0Response._0;
                return Promise.reject({
                            RE_EXN_ID: AuthenticationError,
                            _1: auth_error.error,
                            _2: auth_error.error_description
                          });
              }), checkSessionWithClient(Auth0Client$LiveRoom.make(auth0CustomDomainConfig(undefined))));
}

var listenerCount = {
  contents: 0
};

function useToken(name) {
  var match = React.useState(function () {
        return currentToken.contents;
      });
  var setToken = match[1];
  var listener = React.useMemo((function () {
          return name + ("--" + String(listenerCount.contents));
        }), []);
  React.useEffect((function () {
          listeners.contents = Belt_List.setAssoc(listeners.contents, listener, (function (newToken) {
                  Curry._1(setToken, (function (param) {
                          return newToken;
                        }));
                }), (function (prim0, prim1) {
                  return prim0 === prim1;
                }));
          if (Caml_obj.equal(currentToken.contents, {
                  NAME: "TokenInit",
                  VAL: "NotRequested"
                })) {
            currentToken.contents = {
              NAME: "TokenInit",
              VAL: "Requesting"
            };
            Js_promise.$$catch((function (err) {
                    console.log("Js.Promise catch", err);
                    currentToken.contents = "Unauthenticated";
                    notifyListeners(currentToken.contents);
                    return Promise.resolve(err);
                  }), Js_promise.then_((function (param) {
                        notifyListeners(currentToken.contents);
                        var match = currentToken.contents;
                        if (typeof match === "object" && match.NAME === "Authenticated") {
                          startRefreshLoop(match.VAL.expiresIn);
                        }
                        return Promise.resolve(undefined);
                      }), fetchInitialToken(undefined)));
          }
          return (function (param) {
                    listeners.contents = Belt_List.removeAssoc(listeners.contents, listener, (function (prim0, prim1) {
                            return prim0 === prim1;
                          }));
                  });
        }), []);
  return match[0];
}

var auth0Timeout = 5000;

export {
  AuthenticationError ,
  UserStatusGraphQL ,
  UserStatusQuery ,
  auth0Timeout ,
  MakeAuthZeroParser ,
  AuthZeroParser ,
  optionalBoolParam ,
  originParam ,
  transactionalUpgradeOptionParameters ,
  showSelectAccountParam ,
  accountIdParam ,
  bidOnBehalfParam ,
  agreementStatusesParamPrefix ,
  queryParameters ,
  buildLoginURL ,
  buildRegisterURL ,
  triggerLogin ,
  triggerRegister ,
  triggerTransactionalUpgrade ,
  isRevokedTransactionalUser ,
  isDowngradedTransactionalUser ,
  auth0CustomDomainConfig ,
  auth0CustomClient ,
  currentToken ,
  listeners ,
  checkSessionWithClient ,
  notifyListeners ,
  startRefreshLoop ,
  fetchInitialToken ,
  listenerCount ,
  useToken ,
}
/* UserStatusQuery Not a pure module */
